import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { PlatformDataService } from '@zhik/core/services/platform-data';

@Component({
  selector: 'dskhome-footer-card',
  templateUrl: './footer-card.component.html',
  styleUrls: ['./footer-card.component.scss'],
  imports: [MatCard, MatCardContent, MatIcon, MatButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterCardComponent {
  private readonly platformDataService = inject(PlatformDataService);

  openFeedbackPage(): void {
    this.platformDataService.window?.open(
      'mailto:dskhome@dskbank.bg?subject=DSKhome feedback',
      '_blank',
    );
  }
}
